import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:5000/api',
  baseURL: 'https://node.metromenswear.com/api',
  withCredentials: true
});

// Add Authorization header interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mmw_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
